import React from "react";
import { Link } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import { motion } from "framer-motion";

// Stagger container for content elements
const contentVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

// Standard vertical fade up
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const FeatureCard = ({ item, reverse, imageBottom }) => {
  return (
    <section className={`feature-block ${reverse ? "reverse" : ""}`}>
      <div className="container">
        <div className="feature-inner">

          {/* LEFT CONTENT */}
          <motion.div
            className="feature-content"
            variants={contentVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.span
              className="feature-subheading"
              variants={fadeUp}
            >
              {item.subheading}
            </motion.span>

            <motion.h2
              className="section-heading"
              variants={fadeUp}
            >
              {item.heading}
            </motion.h2>

            <motion.p
              className="section-text"
              variants={fadeUp}
            >
              {item.desc}
            </motion.p>

            <motion.div
              className="feature-points"
              variants={contentVariant}
            >
              {item.points.map((point, i) => (
                <motion.div
                  key={i}
                  className="feature-point"
                  variants={fadeUp}
                  whileHover={{ x: 6 }}
                  transition={{ duration: 0.2 }}
                >
                  <div>
                    <FiCheck />
                  </div>
                  <span>{point}</span>
                </motion.div>
              ))}
            </motion.div>

            <motion.div variants={fadeUp}>
              <Link to="/book-a-demo" className="feature-link">
                Book a Free Demo →
              </Link>
            </motion.div>
          </motion.div>

          {/* RIGHT IMAGE */}
    <motion.div
  className={`feature-image ${imageBottom ? "image-bottom" : ""}`}
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.3 }}
>
            <img
              src={item.image}
              alt={`${item.heading} | Onbbits`}
              loading="lazy"
    decoding="async"
            />
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default FeatureCard;